
import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Form,
  Input,
  FormGroup,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,

} from "reactstrap";
import Avatar from 'react-avatar';
import ReactAvatarEditor from 'react-avatar-editor';
import Dropzone from 'react-dropzone';
import drag from 'assets/img/drag.PNG';
import profilebg from "assets/img/bg15.jpg";
import { Scrollbars } from 'react-custom-scrollbars';
import UserService from '../../services/api/User';
import { toast } from 'react-toastify';

// core components
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";

class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      image: 'favicon.png',
      allowZoomOut: false,
      position: { x: 0.5, y: 0.5 },
      scale: 1,
      rotate: 0,
      borderRadius: 100,
      preview: null,
      width: 125,
      height: 125,   
      modalClassic: false,
      swidth: window.innerWidth,
      sheight: window.innerHeight,
      userData: {}
    }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

    }
    handleNewImage = e => {
      this.setState({ image: e.target.files[0] })
    }                                                                                                                                                     
    onDismiss = () => {};
    toggleModalClassic = (e) => {
      e.preventDefault();
      this.setState({
        modalClassic: !this.state.modalClassic
      });
    };
  
    handleSave = (data) => {
      const img = this.editor.getImageScaledToCanvas().toDataURL()
      const rect = this.editor.getCroppingRect()
      this.setState({
        preview: {
          img,
          rect,
          scale: this.state.scale,
          width: this.state.width,
          height: this.state.height,
          borderRadius: this.state.borderRadius,
        },
        modalClassic: !this.state.modalClassic,
        userData: {...this.state.userData, photoURL: img}
      })
    }
    componentDidMount() {
      this.updateWindowDimensions();
      window.addEventListener('resize', this.updateWindowDimensions);

      let currentUser = JSON.parse(localStorage.getItem("UserProfile"));
      this.setState({
        userData: currentUser
      })
    }
    componentWillUnmount() {
      window.removeEventListener('resize', this.updateWindowDimensions);
    }
    
    updateWindowDimensions() {
      this.setState({ swidth: window.innerWidth, sheight: window.innerHeight});
    }
    handleScale = e => {
      const scale = parseFloat(e.target.value)
      this.setState({ scale })
    }
  
    handleAllowZoomOut = ({ target: { checked: allowZoomOut } }) => {
      this.setState({ allowZoomOut })
    }
  
    rotateLeft = e => {
      e.preventDefault()
  
      this.setState({
        rotate: this.state.rotate - 90,
      })
    }
  
    rotateRight = e => {
      e.preventDefault()
      this.setState({
        rotate: this.state.rotate + 90,
      })
    }
  
    handleBorderRadius = e => {
      const borderRadius = parseInt(e.target.value)
      this.setState({ borderRadius })
    }
  
    handleXPosition = e => {
      const x = parseFloat(e.target.value)
      this.setState({ position: { ...this.state.position, x } })
    }
  
    handleYPosition = e => {
      const y = parseFloat(e.target.value)
      this.setState({ position: { ...this.state.position, y } })
    }
  
    handleWidth = e => {
      const width = parseInt(e.target.value)
      this.setState({ width })
    }
  
    handleHeight = e => {
      const height = parseInt(e.target.value)
      this.setState({ height })
    }
  
    logCallback(e) {
      // eslint-disable-next-line no-console
      // console.log('callback', e)
    }
  
    setEditorRef = editor => {
      if (editor) this.editor = editor
    }
  
    handlePositionChange = position => {
      this.setState({ position })
    }
  
    handleDrop = acceptedFiles => {
      this.setState({ image: acceptedFiles[0] })
    }

  handleFirstNameChange = (e) => {
    e.preventDefault();
    var userData = this.state.userData;
    userData.firstName = e.target.value;
    this.setState({
      userData: userData
    })
  }

  handleLastNameChange = (e) => {
    e.preventDefault();
    var userData = this.state.userData;
    userData.lastName = e.target.value;
    this.setState({
      userData: userData
    })
  }

  updateProfile = (e) => {
    e.preventDefault();
    let data = this.state.userData
    let constructFormData = {
      firstName: data.firstName,
      lastName: data.lastName,
      organisation: localStorage.getItem("accountId"),
      photoURL: data.photoURL
    }
    UserService.UpdateUser(constructFormData, localStorage.getItem("Uid"))
    .then((response) => {
      if(response.status === 'SUCCESS'){
        toast.success('successfully done'); 
      }
    })
  }
  
  render() {
    return (
      <>
        <PanelHeader size="sm" />
        <div className="content">
          <Row>
            <Col md="8">
              <Card>
                <CardHeader>
                  <h5 className="title">My Account</h5>
                </CardHeader>
                <CardBody>
                <Scrollbars autoHeight autoHeightMin={this.state.sheight-220}>
                <div className="carcontent">
                  <Form onSubmit={this.updateProfile} noValidate>
                    <h6 className="heading-small text-muted mb-4">
                      User information
                    </h6>
                    <div className="pl-lg-4">
                      <Row>
                        {/* <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-username"
                            >
                              Username
                            </label>
                            <Input
                              className="form-control-alternative"
                              defaultValue="lucky.jesse"
                              id="input-username"
                              disabled
                              value={currentUser.firstName}
                              placeholder="Username"
                              type="text"
                            />
                          </FormGroup>
                        </Col> */}
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                            >
                              Email address
                            </label>
                            <Input
                              className="form-control-alternative mb-3"
                              id="input-email"
                              defaultValue={this.state.userData.email}   
                              disabled
                              type="email"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                            >
                              First name
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-first-name"
                              defaultValue={this.state.userData.firstName}
                              placeholder="First name"
                              type="text"
                              name="fname"
                              onChange={this.handleFirstNameChange}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                            >
                              Last name
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-last-name"
                              defaultValue={this.state.userData.lastName}
                              placeholder="Last name"
                              type="text"
                              name="lname"
                              onChange={this.handleLastNameChange}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <Button type="submit" color="primary" size="sm" >Update</Button>
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                   
                  </Form>
                </div>
                </Scrollbars>
                </CardBody>
              </Card>
            </Col>
            <Col md="4">
              <Card className="card-user">
              <div className="proimage">
                <div className="image profile" style={{maxWidth:window.innerHeight < 1080 ? 570 : 595}}>
                  <img alt="..." src={profilebg}/>
                </div>
                </div>
                <CardBody style={{minHeight:this.state.sheight-220}} >
                <div className="carcontent">
                  <div className="author">
                    <a href="#" onClick={this.toggleModalClassic}>
                    {this.state.userData.photoURL == null ? (
                          <div><Avatar round={true} color={Avatar.getRandomColor('sitebase', ['violet', 'coral', '#851fc4','sandybrown'])} className="avatar border-gray" name= {this.state.userData.firstName +" "+ this.state.userData.lastName} size="100" 
                          /><div className="profilepic"><i className="fas fa-camera"/></div></div>
                          

                      ) : <div><img src={this.state.userData.photoURL} alt={this.state.userData.firstName} style={{borderRadius:'50px', width:'100px',height:'100px'}} className="avatar border-gray" 
                       /><div className="profilepic"><i className="fas fa-camera"/></div></div>}
                    <h5 className="title"> {this.state.userData.firstName} {this.state.userData.lastName}</h5>
                    </a>
                    
                  </div>
                
         
            {/*  onClick={this.toggleModalClassic} <ReactAvatarEditor
              scale={parseFloat(this.state.scale)}
              width={this.state.width}
              height={this.state.height}
              position={this.state.position}
              onPositionChange={this.handlePositionChange}
              rotate={parseFloat(this.state.rotate)}
              borderRadius={this.state.width / (100 / this.state.borderRadius)}
              image={this.state.image}
              className="editor-canvas"
            />
          </div>
        <br />
        New File:
        <input name="newImage" type="file" onChange={this.handleNewImage} />
        <br />
        Zoom:
        <input
          name="scale"
          type="range"
          onChange={this.handleScale}
          min={this.state.allowZoomOut ? '0.1' : '1'}
          max="2"
          step="0.01"
          defaultValue="1"
        /> */}
       
      <Modal
                        isOpen={this.state.modalClassic}
                        toggle={this.toggleModalClassic}
                        className="text-center"
                        backdrop="static"
                      >
                        <ModalHeader
                          className="justify-content-center uppercase title"
                          toggle={this.toggleModalClassic}
                          tag="h6"
                        >
                         Profile Picture 
                        </ModalHeader>    
                        <ModalBody>
                        <div>
         <Dropzone
          onDrop={this.handleDrop}
          disableClick
          multiple={false}
          style={{ width: this.state.width, height: this.state.height, marginBottom:'35px' }}
        >
         {({getRootProps}) => (
    <div {...getRootProps()}>

<div className="image-upload">
  <label for="file-input">
    <img src={drag} onChange={this.handleNewImage} style={{cursor:'pointer'}}/>
  </label>
        <input name="newImage"  id="file-input" type="file" onChange={this.handleNewImage} />
      </div>
         
          
      </div>
  )}
        </Dropzone>
        <br />
        <div>
            <ReactAvatarEditor
              ref={this.setEditorRef}
              scale={parseFloat(this.state.scale)}
              width={this.state.width}
              height={this.state.height}
              position={this.state.position}
              onPositionChange={this.handlePositionChange}
              rotate={parseFloat(this.state.rotate)}
              borderRadius={this.state.width / (100 / this.state.borderRadius)}
              onLoadFailure={this.logCallback.bind(this, 'onLoadFailed')}
              onLoadSuccess={this.logCallback.bind(this, 'onLoadSuccess')}
              onImageReady={this.logCallback.bind(this, 'onImageReady')}
              image={this.state.image}
              className="editor-canvas"
            />
          </div>
         {/* {!!this.state.preview && (
          <img
            src={this.state.preview.img}
            style={{
              borderRadius: `${(Math.min(
                this.state.preview.height,
                this.state.preview.width
              ) +
                10) *
                (this.state.preview.borderRadius / 2 / 100)}px`,
            }}
          />
        )} */}
      </div>
       </ModalBody>
                        <ModalFooter>
                          <Button color="default" onClick={this.handleSave}>Set as a Profile Photo</Button>
                          <Button
                            color="danger"
                            onClick={this.toggleModalClassic}
                          >
                            Cancel
                          </Button>
                        </ModalFooter>
                      </Modal>
              </div>
                </CardBody>
                   
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

export default Profile;
